export const DATASET = 'dataset';
export const ROUTER_DATASET = 'router_dataset';
export const WIDGET_DATASET = 'widget';
export const ALL_DATASET_TYPES = [DATASET, ROUTER_DATASET, WIDGET_DATASET];
//# sourceMappingURL=datasetTypes.js.map